const locale = {
  placeholder: 'Zaman SeÃ§',
};

export default locale;
